<template>
  <transition-group
    name="notifications"
    tag="div"
    :class="['notification-wrapper', `top-${topSize}`]"
  >
    <DesignSystemNotification
      v-for="notification in notifications"
      :key="notification.id"
      v-model="notification.isActive"
      :type="notification.type"
      :duration="notification.duration"
      :light="true"
      :data-error-code="notification.errorCode"
      @close="removeNotification(notification.id)"
    >
      <span>{{ notification.message }}</span>
    </DesignSystemNotification>
  </transition-group>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useNotificationStore } from "~/stores/notifications";

const notificationStore = useNotificationStore();
const notifications = computed(() => notificationStore.notifications);

interface NotificationProps {
  topSize?: "small" | "medium" | "large";
}
const { topSize = "large" } = defineProps<NotificationProps>();
const removeNotification = (id: number) => {
  notificationStore.removeNotification(id);
};
</script>

<style lang="scss" scoped>
.notification-wrapper {
  position: fixed;
  z-index: 9999;
  right: 0;
  display: flex;
  width: min(100%, 444px);
  flex-direction: column;
  padding: 0 24px;

  @media screen and (min-width: $breakpoint-desktop) {
    padding: 0 30px;
  }
}

.top-small {
  top: 45px;
}

.top-medium {
  top: 80px;
}

.top-large {
  top: 100px;
}
</style>
